import { Content } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import { StarIcon } from './StarIcon';
import styles from './StatsBlock.module.scss';

interface Props {
  slice: Content.ExtendedTestimonialsSlice;
}

const StatsBlock = ({ slice }: Props) => {
  return (
    <article className={styles.wrapper}>
      <div className={styles.headingBlock}>
        <div className={`${styles.title} ${styles.desktopTitle}`}>
          <PrismicRichText field={slice.primary.title} />
        </div>
        <div className={`${styles.title} ${styles.mobileTitle}`}>
          <PrismicRichText field={slice.primary.mobile_title} />
        </div>
        <div className={styles.subtitleWrapper}>
          <div className={styles.starsWrapper}>
            {[0, 1, 2, 3, 4].map((star) => (
              <StarIcon key={star} className={styles.starIcon} />
            ))}
          </div>
          <p className={styles.subtitle}>{slice.primary.subtitle}</p>
        </div>
      </div>
      <ul className={styles.statsBlock}>
        {slice.primary.stats.map((stat) => (
          <li key={stat.title} className={styles.statItem}>
            <span className={styles.statTitle}>{stat.title}</span>
            <span className={styles.statValue}>{stat.value}</span>
          </li>
        ))}
      </ul>
    </article>
  );
};

export default StatsBlock;
